import createUmbracoMediaItemProps from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'
import { MediaComponent } from '.'

export default function mediaComponentFactory(
  data: any,
  key: number | string,
): JSX.Element {
  const content = data?.content?.properties

  const mediaItem = content?.media?.items[0].content
  const mediaItemProps = createUmbracoMediaItemProps({
    mediaItemContent: mediaItem,
    umbracoBaseUrl: GetUmbracoBaseUrl(),
  })

  return (
    <MediaComponent
      key={key}
      mediaData={mediaItemProps}
      isFullWidth={content?.isFullWidth}
    />
  )
}
